import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface NivelProbabilidadPesvItem {
  id: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class NivelProbabilidadPesvService {
  private apiUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<NivelProbabilidadPesvItem[]> {
    return this.http.get<NivelProbabilidadPesvItem[]>(`${this.apiUrl}/nivel_provabilidad_pesv`, {
      withCredentials: true,
    });
  }

  getById(id: number): Observable<NivelProbabilidadPesvItem> {
    return this.http.get<NivelProbabilidadPesvItem>(`${this.apiUrl}/nivel_provabilidad_pesv/${id}`, {
      withCredentials: true,
    });
  }
}